import {
  MedScreenName,
  trackMarketplaceViewed,
} from "../../../nativeAnalytics/medAnalytics";
import { useTrackOnceWithRetry } from "../../../nativeAnalytics/hooks/useTrackOnceWithRetry";

const logPrefix = "[MarketplaceAnalytics]";

/**
 * Fires `care_tab_marketplace` page-view when the component that calls
 * this hook mounts. Same caller contract as `useTrackCareTabViewed`:
 * call from a LEAF component that only mounts once placements are ready
 * to render (i.e. inside the success branch), so the event fires
 * alongside content the user actually sees.
 */
export function useTrackMarketplaceViewed() {
  useTrackOnceWithRetry({
    enabled: true,
    dispatch: trackMarketplaceViewed,
    logPrefix,
    logContext: { screenName: MedScreenName.CareTabMarketplace },
  });
}
